export default [
    {
        path: '/tendero/correos',
        meta: { nombre: 'Correos' },
        name: 'tendero.correos',
        component: () => import(/* webpackChunkName: "correos" */ '../../pages/correos/tendero').then(m => m.default || m),
    }
]
